// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wo_a bic_b bic_we"};